module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _vm._l((_vm.rows), function(rowsData) {
    return _c('div', [_c('div', {
      staticClass: "card-header"
    }, [_c('StatisticTable', {
      attrs: {
        "footColumns": rowsData.foot,
        "headColumns": _vm.headColumns,
        "rows": rowsData.rows,
        "title": ((_vm.Helper.getOfferTitle(_vm.offers, rowsData.offer)) + " (" + (rowsData.offer) + ")")
      }
    })], 1)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348aa62a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/webmaster/Grid.vue
// module id = 537
// module chunks = 0